import React, {useState} from 'react';
import styles from "./CreateForm.module.scss";
import {listeExempleFluxRss} from "../../data/listeRSSExample";
import {Button, FormControl} from "react-bootstrap";
import axios from "axios";
import {useStores} from "../../stores/Context";
import {useParams} from "react-router-dom";
import BtnPrimary from "../../boiteAOutils/BtnPrimary";
import BtnSecondary from "../../boiteAOutils/BtnSecondary";

const CreateRSSExample = ({handleCancelAdd}) => {
    const {id, ent} = useParams();
    const {widgetStore} = useStores();
    const [choice, setChoice] = useState("");
    const [widgetName, setWidgetName] = useState('');
    const [alertWidgetName, setAlertWidgetName] = useState(false);
    const [urlFluxRSS, setUrlFluxRSS] = useState("");
    const [alerUrlFluxRSS, setAlerUrlFluxRSS] = useState(false);
    const idTotem = widgetStore.idTotem;

    const handleChoiceFlux = (e, flux) => {
        stopPropagation(e);
        setChoice(flux);
    }

    const handleCancelAddd = (e) => {
        stopPropagation(e);
        setChoice("");
    }

    const createRss = (fluxSend) => {
        let flux = {
            rss_name: fluxSend.titre
            , rss_URL: fluxSend.url
            , rss_id_totem: idTotem
            , rss_img: fluxSend.url_img
        }
        axios.post(process.env.REACT_APP_API_URL + '/api/addFluxRss/' + idTotem, flux,
            {headers: {"Authorization": `Bearer ${widgetStore.getCookie("current_apiToken")}`}}
        )
            .then(() => {
                widgetStore.loadRSS();
                handleCancelAdd();
            });
    }

    const createCustomRSS = () => {
        if (widgetName.length >= 3 && urlFluxRSS.length >= 5) {
            setAlertWidgetName(false);
            setAlerUrlFluxRSS(false);
            let flux = {
                rss_name: widgetName
                , rss_URL: urlFluxRSS
                , rss_id_totem: idTotem
                , rss_img: null
            }
            axios.post(process.env.REACT_APP_API_URL + '/api/addFluxRss/' + idTotem, flux,
                {headers: {"Authorization": `Bearer ${widgetStore.getCookie("current_apiToken")}`}}
            )
                .then(() => {
                    widgetStore.loadRSS();
                    handleCancelAdd();
                });
        } else {
            if (widgetName.length < 3) {
                setAlertWidgetName(true);
            } else {
                setAlertWidgetName(false);
            }
            if (urlFluxRSS.length < 5) {
                setAlerUrlFluxRSS(true);
            } else {
                setAlerUrlFluxRSS(false);
            }
        }
    }

    const stopPropagation = (event) => {
        event.stopPropagation();
        event.preventDefault();
    };

    return (
        <div className={styles.listeChampsFormulaire}>
            {choice === "" ? (
                <>
                    <div className={styles.form_add_widget}>
                        <label>Nom du Flux RSS </label>
                        <FormControl className={""} onChange={(e) => {
                            setWidgetName(e.target.value)
                        }} value={widgetName} placeholder={"ex: Informations Dieppoise"}/>
                        {alertWidgetName && (
                            <p className={"text-danger"}>Minimum 3 caractères</p>
                        )}
                    </div>
                    <div className={styles.form_add_widget}>
                        <label>URL du Flux RSS </label>
                        <FormControl className={""} value={urlFluxRSS} onChange={(e) => {
                            setUrlFluxRSS(e.target.value)
                        }} placeholder={"https://www.example.com/flux.rss"}/>
                        {alerUrlFluxRSS && (
                            <p className={"text-danger"}>Minimum 5 caractères</p>
                        )}
                    </div>
                    <div className={styles.WidgetButtonContent}>
                        <BtnSecondary onClick={handleCancelAdd}>Retour à la liste</BtnSecondary>
                        <BtnPrimary onClick={createCustomRSS} children={"Valider"}/>
                    </div>
                    <h1 className={styles.WidgetTitre}>{choice === "" ? "Exemples de Flux RSS" : `Flux RSS - ${choice}`}</h1>
                    <div className={"WidgetTypeChoixContent"}>
                        {listeExempleFluxRss.map((item, k, i) => {
                            return (
                                <div className={"WidgetTypeChoixCard"}
                                     onClick={(e) => handleChoiceFlux(e, item.nom)}
                                     onTouchEnd={(e) => handleChoiceFlux(e, item.nom)}>
                                    <img src={item.url_img} alt="" style={{width: "10em"}}/>
                                </div>
                            );
                        })}
                    </div>
                </>
            ) : (
                <div className={"mt-5"}>
                    <Button
                        type={"button"}
                        style={{position: "absolute", top: "3em", right: "1em", zIndex: "79789798465456"}}
                        onClick={(e) => handleCancelAddd(e)}
                        onTouchEnd={(e) => handleCancelAddd(e)}>Retour à la liste</Button>
                    {
                        listeExempleFluxRss.filter(flux => flux.nom === choice)[0].listFlux.map((item, k, i) => {
                            return (
                                <div className={`col-9 mx-auto my-3 `} style={{position: "relative"}}>
                                    <div
                                        className={`row ${styles.fluxRss}`}
                                        onTouchStart={(e) => createRss(item)}
                                        onClick={(e) => createRss(item)}
                                    >
                                        <div className="col-4 border p-3">
                                            <img
                                                src={listeExempleFluxRss.filter(flux => flux.nom === choice)[0].url_img}
                                                className={"mx-auto"} alt="Logo flux rss"
                                                style={{maxHeight: "3em", maxWidth: "100%"}}/>
                                        </div>
                                        <div className="col-8 border p-3">
                                            <h5>{item.titre}</h5>
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
            )}
        </div>
    );
};

export default CreateRSSExample;